export enum DashboardDataLinksAction {
	RefreshDashboard = 'refreshdashboard',
	NavigateTo       = 'navigateto'
}
